import { AccrediblePageMeta, CustomAttributeType } from '@accredible-frontend-v2/models';
import {
  SpotlightProfile,
  SpotlightProfilesFilters,
  SpotlightProfilesOrder,
  SpotlightSearchByOptions,
} from '../entities/spotlight-profiles.model';

export const getMockedSpotlightProfilesFilters = (
  profileFilters?: Partial<SpotlightProfilesFilters>,
): SpotlightProfilesFilters => ({
  page: 1,
  page_size: 10,
  search_term: 'test',
  search_by: SpotlightSearchByOptions.PROFILE_NAME,
  order: SpotlightProfilesOrder.DEFAULT_NEWEST,
  groups: [],
  organizations: [],
  location: '',
  lat: 0,
  lng: 0,
  city: '',
  custom_location_distance: '',
  country: 'US',
  state: 'CA',
  viewport: null,
  skills: [],
  skill_category_ids: [],
  availability: [],
  custom_attributes: [
    {
      id: 1,
      label: 'Test Attribute',
      type: CustomAttributeType.TEXT,
      searchable: true,
      value: 'value1',
    },
    {
      id: 2,
      label: 'Test Attribute 2',
      type: CustomAttributeType.SELECT_ANY,
      searchable: true,
      value: [2, 3],
    },
  ],
  ...profileFilters,
});

export const getMockSpotlightProfile = (profile?: Partial<SpotlightProfile>): SpotlightProfile => ({
  id: '1',
  name: 'Test Profile',
  username: 'test',
  credentials: [],
  updated_at: '2021-01-01T00:00:00Z',
  custom_attributes_values: [],
  skills: [],
  bio: '',
  location: {
    place_id: 'test-place-id',
    name: 'Test Location',
    geo: {
      lat: 0,
      lng: 0,
      viewport: null,
    },
  },
  avatar_url: '',
  social_media: {},
  course_recommendations_enabled: false,
  encoded_id: 1,
  visibility: { 1: true },
  user_work_experiences: [],
  availability: [],
  mfa_settings: {
    id: '1',
    configured: false,
    method: 'authenticator',
  },
  ...profile,
});

export const getMockedSpotlightProfilesResponse = (
  profiles: SpotlightProfile[] = [getMockSpotlightProfile()],
): {
  meta: AccrediblePageMeta;
  profiles: SpotlightProfile[];
} => ({
  meta: { total_count: 1, total_pages: 1 } as AccrediblePageMeta,
  profiles: profiles,
});
